import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useCallback } from "react";
import checkUserPackageSessionsAction from "~/store/actions/checkUserPackageSessionsAction";
import bookingTransactionService from "~/services/bookingTransactionService";
import { mixpanelTrackEvent } from "~/utils/mixpanel";
import Utils from "~/helpers/Utils";

export const useCheckSessionPackage = () => {
	const dispatch = useDispatch();
	const { business } = useSelector((state) => state.business);
	const { sessionsPackagesAvailable, sessionsAccepted } = useSelector((state) => state.checkUserPackageSessions);
	const { user } = useSelector((store) => store.auth);
	const meStoreFromStore = useSelector((store) => store.me?.me);
	const me = Utils.safeParseJSON("@prit-web/meData", meStoreFromStore);
	const currentUser = me || user || {};
	const typeLogin = Utils.safeLocalGet("@prit-web/TypeLogin");

	const businessId = business?.id;

	// services: [{ service_id, professional_id }]
	const listSessionsPackage = useCallback((services) => {
		if (!user || user?.isAnonymous) return;

		if (!businessId || !services || services.length === 0) return;
		dispatch(checkUserPackageSessionsAction.sessionsPackagesAvailable(businessId, services));
	}, [dispatch, businessId, user]);

	const clearSessionsAccepted = useCallback(() => {
		dispatch(checkUserPackageSessionsAction.clearSessionsAccepted());
	}, [dispatch]);

	const updateScheduleSession = async (bookingData) => {
		return bookingTransactionService
			.putBookingUpdateSchedule({
				bookingId: bookingData.bookingId,
				data: {
					start_time: bookingData?.payload?.start_time,
					end_time: bookingData?.payload?.end_time,
					acesso: "web",
					answer: bookingData?.observation,
				},
			})
			.then(() => {
				mixpanelTrackEvent(
					"Ativacao_Pacote_Sessao",
					{
						Origem: "Checkout",
						Pacote: bookingData?.infoPackage?.packageName,
						Pacote_Sessao_Id: bookingData?.bookingId,
						Servico_Nome: bookingData?.services?.[0]?.service?.serviceName,
						Valor_Sessao: Utils.getPostPrice(bookingData?.infoPackage?.servicePricePackage, business?.currency) || "0",
						Telefone_Cliente: currentUser?.phone,
						Tipo_de_Login: typeLogin || null
					},
					currentUser,
					business
				);
			})
			.catch((err) => {
				let message = err?.response?.data?.message || err?.message || err;
				console.error("Erro no updateScheduleSession:", message);
				throw err;
			});
	};

	return {
		listSessionsPackage,
		updateScheduleSession,
		clearSessionsAccepted,
		sessionsPackagesAvailable,
		sessionsAccepted
	};
};

export default useCheckSessionPackage;
